'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

require('../styles/Layout.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DRAWER_OPEN_CLASS = 'drawer-open';

var Layout = function (_BcReactComponent) {
  _inherits(Layout, _BcReactComponent);

  function Layout() {
    _classCallCheck(this, Layout);

    return _possibleConstructorReturn(this, (Layout.__proto__ || Object.getPrototypeOf(Layout)).apply(this, arguments));
  }

  _createClass(Layout, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      Layout.toggleBodyScrolling(this.props.open);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.open !== this.props.open) {
        Layout.toggleBodyScrolling(nextProps.open);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      Layout.toggleBodyScrolling(false);
    }
  }, {
    key: 'getDrawerClasses',
    value: function getDrawerClasses(open) {
      var activeClass = open ? 'active' : '';
      return 'cp-layout ' + this.props.containerClass + ' ' + activeClass + ' drawer-layout-left row';
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { className: this.getDrawerClasses(this.props.open) },
        _react2.default.Children.map(this.props.children, function (child) {
          return _react2.default.cloneElement(child, { open: _this2.props.open });
        })
      );
    }
  }], [{
    key: 'toggleBodyScrolling',
    value: function toggleBodyScrolling(open) {
      var method = open ? 'add' : 'remove';
      document.body.classList[method](DRAWER_OPEN_CLASS);
    }
  }]);

  return Layout;
}(_baseBcReactComponent2.default);

Layout.propTypes = {
  open: _react.PropTypes.bool,
  containerClass: _react.PropTypes.string
};

exports.default = Layout;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-drawer/lib/components/layout/components/Layout.component.js
// module id = 1061
// module chunks = 1